import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Stepper,
    Step,
    StepLabel,
    Alert,
    CircularProgress,
    Autocomplete,
    Card,
    CardContent,
    Paper,
    Stack,
    Chip,
    IconButton,
    InputAdornment,
    Divider,
    Tooltip
} from '@mui/material';
import {StepCategoriaEProdutos} from "./StepCategoriaEProdutos";
import {
    Search as SearchIcon,
    Clear as ClearIcon,
    Category as CategoryIcon,
    Delete as DeleteIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    Security as SecurityIcon,
    ArrowBack as ArrowBackIcon,
    Save as SaveIcon
} from '@mui/icons-material';

import { Controller } from 'react-hook-form';
import { useState, useMemo } from 'react';

export function GHEFormSecondStep({
                                    empresas,
                                    carregaCategorias,
                                    produtos,
                                    allowInteraction,
                                    exibirAlerta,
                                    isEditAction,
                                    isLoading,
                                    getFormErrorMessage,
                                    setValue,
                                    getValues,
                                    register,
                                    unregister,
                                    errors,
                                    watch,
                                    control,
                                    setCards,
                                    cards,
                                    existingCards,
                                    setSelectedCard,
                                    selectedCard,
                                    setSelectedCardInfo,
                                    selectedCardInfo,
                                    categoriasEProdutos,
                                    selectedGHE,
                                    setGheEmpresaId,
                                    gheEmpresaId
                                  }) {
    const [gheNome, setGheNome] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [searchCategoria, setSearchCategoria] = useState('');

    const steps = ["Informações Gerais", "Categorias e Permissões"];

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const categoriasOrdenadas = useMemo(() => {
        if (!cards || cards.length === 0) return [];

        return cards
            .filter(card =>
                card.nome.toLowerCase().includes(searchCategoria.toLowerCase())
            )
            .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    }, [cards, searchCategoria]);

    const desativado = isEditAction && !selectedGHE?.status;
    const nomeRegister = register('nome', { required: true });

    return (
        <>
            <Box sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                p: 3,
                mb: 3,
                boxShadow: 1
            }}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel
                                sx={{
                                    '& .MuiStepLabel-label': {
                                        fontSize: '1rem'
                                    }
                                }}
                            >
                                {label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>

            <FormControl variant="standard" fullWidth>
                
                {activeStep === 0 && (
                    <Box sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        p: 4,
                        boxShadow: 1
                    }}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} md={8} lg={6}>
                                
                                <Box sx={{
                                    mb: 4,
                                    pb: 2,
                                    borderBottom: '3px solid',
                                    borderColor: 'primary.main'
                                }}>
                                    <Typography
                                        variant='h3'
                                        component={'h3'}
                                        sx={{
                                            mb: 1,
                                            color: 'primary.main',
                                            fontWeight: 600
                                        }}
                                    >
                                        Informações Gerais
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Utilize os campos abaixo para inserir informações que facilitam a identificação do GHE.
                                    </Typography>
                                </Box>

                                <Stack spacing={2.5}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        label="Nome"
                                        required
                                        placeholder="Digite o nome do GHE"
                                        name="nome"
                                        autoComplete='off'
                                        error={errors.nome && true}
                                        helperText={errors.nome && 'O Nome é obrigatório.'}
                                        fullWidth
                                        {...nomeRegister}
                                        variant="outlined"
                                        {...register('nome', { required: true })}
                                        disabled={!allowInteraction && !desativado}
                                        onChange={(e) => {
                                            register('nome').onChange(e);
                                            setGheNome(e.target.value);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&:hover fieldset': {
                                                    borderColor: 'primary.main',
                                                }
                                            }
                                        }}
                                    />

                    <Controller
                        name="descricao"
                        control={control}
                        defaultValue=""
                        disabled={!allowInteraction && !desativado}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                disabled={!allowInteraction && !desativado}
                                InputLabelProps={{ shrink: true }}
                                label="Descrição"
                                placeholder="Digite a Descrição"
                                fullWidth
                                multiline
                                rows={3}
                            />
                        )}
                    />
                                    {desativado && (
                                        <Alert
                                            severity="warning"
                                            sx={{
                                                width: '100%',
                                                boxSizing: 'border-box',
                                                alignItems: 'flex-start'
                                            }}
                                        >
                                            Só é possível editar o Nome e a Descrição deste GHE pois ela está desativada. Ative-a para poder editar todos os dados.
                                        </Alert>
                                    )}

                                    <Box
                                        component="fieldset"
                                        disabled={desativado}
                                        sx={{
                                            border: 0,
                                            p: 0,
                                            m: 0,
                                            minWidth: 0,
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 2.5,
                                            opacity: desativado ? 0.5 : 1,
                                            cursor: desativado ? 'not-allowed' : 'auto',
                                            userSelect: desativado ? 'none' : 'auto'
                                        }}
                                    >
                                    <Controller
                                        name="observacao"
                                        control={control}
                                        defaultValue=""
                                        disabled={!allowInteraction || desativado}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                InputLabelProps={{ shrink: true }}
                                                label="Observação"
                                                placeholder="Digite a Observação"
                                                name="observacao"
                                                fullWidth
                                                multiline
                                                rows={3}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '&:hover fieldset': {
                                                            borderColor: 'primary.main',
                                                        }
                                                    }
                                                }}
                                            />
                                        )}
                                    />

                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        label='Código Externo'
                                        placeholder='Digite o código externo'
                                        name='cod_externo'
                                        fullWidth
                                        {...register("cod_externo", { required: false })}
                                        error={!!errors.cod_externo}
                                        helperText={getFormErrorMessage(errors, 'cod_externo')}
                                        variant="outlined"
                                        disabled={!allowInteraction || desativado}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&:hover fieldset': {
                                                    borderColor: 'primary.main',
                                                }
                                            }
                                        }}
                                    />

                                    {empresas && empresas.length > 0 ? (
                                        <FormControl fullWidth>
                                            <InputLabel id="empresa-select-label">Empresa *</InputLabel>
                                            <Controller
                                                name="id_empresa"
                                                control={control}
                                                rules={{ required: 'O campo Empresa é obrigatório' }}
                                                render={({ field }) => (
                                                    <Select
                                                        labelId="empresa-select-label"
                                                        label="Empresa *"
                                                        {...field}
                                                        error={!!errors.id_empresa}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            const selectedEmpresaId = e.target.value;
                                                            setValue('id_empresa', selectedEmpresaId);
                                                            carregaCategorias();
                                                            setCards([]);
                                                            setValue('listaCategorias', null);
                                                            setGheEmpresaId(selectedEmpresaId);
                                                        }}
                                                        disabled={isEditAction || desativado}
                                                        sx={{
                                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: 'primary.main',
                                                            }
                                                        }}
                                                    >
                                                        {empresas.map((empresa) => (
                                                            <MenuItem key={empresa.id} value={empresa.id}>
                                                                {empresa.nomeFantasia}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                )}
                                            />
                                            {errors.id_empresa && (
                                                <FormHelperText error>{errors.id_empresa.message}</FormHelperText>
                                            )}
                                        </FormControl>
                                    ) : (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            p: 2,
                                            bgcolor: 'action.hover',
                                            borderRadius: 1
                                        }}>
                                            <CircularProgress size={20} />
                                            <Typography>Carregando empresas...</Typography>
                                        </Box>
                                    )}
                 </Box>
                                    
                                </Stack>

                                {!desativado && (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mt: 4,
                                    pt: 3,
                                    borderTop: '1px solid',
                                    borderColor: 'divider'
                                 }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleNext}
                                        disabled={
                                            !allowInteraction ||
                                            (!selectedGHE && !gheEmpresaId) ||
                                            (!selectedGHE && !gheNome)
                                        }
                                    >
                                        Próximo
                                    </Button>
                               </Box> 
                               )}
                                
                        
                            </Grid>
                            
                        </Grid>
                        
                    </Box>
                )}

                {activeStep === 1 && (
                    <Box sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        p: 3,
                        boxShadow: 1
                    }}>
                        {!gheEmpresaId ? (
                            <Alert
                                severity='warning'
                                sx={{
                                    borderRadius: 2,
                                    fontSize: '1rem'
                                }}
                            >
                                Escolha uma empresa no passo anterior para continuar.
                            </Alert>
                        ) : (
                            <>
                                {isEditAction && (
                                    <Alert
                                        severity="info"
                                        sx={{
                                            mb: 3,
                                            borderRadius: 2,
                                            fontSize: '0.95rem'
                                        }}
                                    >
                                        As alterações realizadas nas categorias e permissões só entrarão
                                        em vigor quando as regras atuais vencerem.
                                    </Alert>
                                )}

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="stretch"
                                    spacing={3}
                                >
                                    
                                    <Grid item xs={12} md={3}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                height: '100%',
                                                boxShadow: 1
                                            }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 2,
                                                pb: 2,
                                                borderBottom: '2px solid',
                                                borderColor: 'divider'
                                            }}>
                                                <AddCircleOutlineIcon color="primary" />
                                                <Typography variant='h6' component={'h3'} fontWeight={600}>
                                                    Adicionar
                                                </Typography>
                                            </Box>

                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
                                                Selecione as categorias ou produtos para este GHE.
                                            </Typography>

                                            <Stack spacing={2.5}>
                                                <Controller
                                                    name="listaCategorias"
                                                    control={control}
                                                    defaultValue={null}
                                                    disabled={isLoading || !allowInteraction}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            options={
                                                                categoriasEProdutos.filter(categoria =>
                                                                    !cards.find(card => card.id === categoria.id)
                                                                )
                                                            }
                                                            getOptionLabel={(option) => option.label ?? option.nome}
                                                            getOptionDisabled={(option) => option.disabled === true}
                                                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                                                            onBlur={() => setValue('listaCategorias', null)}
                                                            onChange={(_, newValue) => {
                                                                if (newValue) {
                                                                    field.onChange(newValue);

                                                                    newValue?.produtos?.forEach(produto => {
                                                                        if (produto) {
                                                                            const isActive = produto.status === 1 || produto.status === true || produto.status === 'ativo';

                                                                            register(`permissoes[${produto.id}].id_produto`, { value: produto.id });
                                                                            register(`permissoes[${produto.id}].id_categoria`, { value: produto.idCategoria || produto.id_categoria});
                                                                            register(`permissoes[${produto.id}].periodo`, { value: produto.periodo || newValue.periodo });
                                                                            register(`permissoes[${produto.id}].ponto_alerta`, { value: produto.ponto_alerta || newValue.ponto_alerta });
                                                                            register(`permissoes[${produto.id}].status`, { value: isActive });
                                                                        }
                                                                    });

                                                                    const registerCategoria = (id, value) => {
                                                                        if (!getValues(`categorias[${id}]`)) {
                                                                            register(`categorias[${id}]`, { value });
                                                                        } else {
                                                                            setValue(`categorias[${id}]`, value);
                                                                        }
                                                                    };

                                                                    registerCategoria(newValue.id, {
                                                                        id_categoria: newValue.id,
                                                                        quantidade_maxima: newValue?.quantidade_maxima,
                                                                        periodo: newValue?.periodo,
                                                                        ponto_alerta: newValue?.ponto_alerta
                                                                    });

                                                                    setCards(prevState => [...prevState, newValue]);
                                                                }
                                                            }}
                                                            noOptionsText={
                                                                categoriasEProdutos.length === 0 && cards.length === 0 ?
                                                                    <Alert severity='error'>A empresa selecionada não possui nenhuma Categoria cadastrada.</Alert>
                                                                    :
                                                                    cards.length === categoriasEProdutos.length ?
                                                                        <Alert severity='info'>Todas as categorias foram adicionadas.</Alert>
                                                                        : 'Nenhum item encontrado.'
                                                            }
                                                            loading={isLoading}
                                                            loadingText={<CircularProgress size={15} />}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Buscar Categoria"
                                                                    variant="outlined"
                                                                    helperText={
                                                                        isLoading
                                                                            ? "Carregando..."
                                                                            : "Digite para buscar"
                                                                    }
                                                                    disabled={isLoading || !allowInteraction}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {isLoading ? (
                                                                                    <CircularProgress color="inherit" size={20} />
                                                                                ) : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                />

                                                <Divider>
                                                    <Chip label="OU" size="small" />
                                                </Divider>

                                                <Controller
                                                    name="listaProdutos"
                                                    control={control}
                                                    defaultValue={null}
                                                    disabled={isLoading || !allowInteraction}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            {...field}
                                                            options={produtos?.filter(
                                                                (produto) =>
                                                                    !cards.find((card) => card.id === produto.idCategoria)
                                                            )}
                                                            filterOptions={(options, state) => {
                                                                const search = state.inputValue.toLowerCase();

                                                                return options.filter((opt) => {
                                                                    const nome = opt.nome?.toLowerCase() ?? "";
                                                                    const ca = opt.ca?.toString().toLowerCase() ?? "";
                                                                    const codExterno = opt.cod_externo?.toString().toLowerCase() ?? "";

                                                                    const codigosFilhos = opt.filhos?.map(
                                                                        filho => filho.cod_externo?.toString().toLowerCase() ?? ""
                                                                    ).join(" ") ?? "";

                                                                    return (
                                                                        nome.includes(search) ||
                                                                        ca.includes(search) ||
                                                                        codExterno.includes(search) ||
                                                                        codigosFilhos.includes(search)
                                                                    );
                                                                });
                                                            }}
                                                            getOptionLabel={(option) => {
                                                                if (!option?.nome) return "";

                                                                const nome = option.nome;
                                                                const ca = option.ca ? `CA ${option.ca}` : "";
                                                                const categoria = option.nomeCategoria || "Sem categoria";

                                                                const codigos = [];
                                                                if (option.cod_externo) codigos.push(option.cod_externo);
                                                                if (option.filhos?.length > 0) {
                                                                    option.filhos.forEach(filho => {
                                                                        if (filho.cod_externo) codigos.push(filho.cod_externo);
                                                                    });
                                                                }

                                                                const codigosTexto = codigos.length > 0 ? `Cód. ${codigos.join(', ')}` : "";
                                                                const inativoTexto = option.inativo ? " - (Inativo)" : "";

                                                                const parts = [ca, codigosTexto, nome].filter(Boolean);

                                                                return `${parts.join(" • ")} | ${categoria}${inativoTexto}`;
                                                            }}
                                                            getOptionDisabled={(option) => option.inativo === true}
                                                            renderOption={(props, option) => {
                                                                const ca = option.ca ? `CA ${option.ca}` : "";
                                                                const categoria = option.nomeCategoria || "Sem categoria";
                                                                const codigos = [];
                                                                if (option.cod_externo) {
                                                                    codigos.push(option.cod_externo);
                                                                }
                                                                if (option.filhos && option.filhos.length > 0) {
                                                                    option.filhos.forEach(filho => {
                                                                        if (filho.cod_externo && !codigos.includes(filho.cod_externo)) {
                                                                            codigos.push(filho.cod_externo);
                                                                        }
                                                                    });
                                                                }

                                                                return (
                                                                    <li {...props} key={option.id}>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', py: 0.5 }}>
                                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                                                                                {ca && (
                                                                                    <Chip
                                                                                        label={ca}
                                                                                        size="small"
                                                                                        color="primary"
                                                                                        variant="outlined"
                                                                                    />
                                                                                )}
                                                                                {codigos.length > 0 && (
                                                                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                                                                        {codigos.map((codigo, index) => (
                                                                                            <Chip
                                                                                                key={index}
                                                                                                label={`Cód. ${codigo}`}
                                                                                                size="small"
                                                                                                color="secondary"
                                                                                                variant="outlined"
                                                                                            />
                                                                                        ))}
                                                                                    </Box>
                                                                                )}
                                                                            </Box>
                                                                            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                                                                                {option.nome}{option.inativo ? ' - (Inativo)' : ''}
                                                                            </Typography>
                                                                            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                                                                {categoria}
                                                                            </Typography>
                                                                        </Box>
                                                                    </li>
                                                                );
                                                            }}
                                                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                                                            onBlur={() => setValue("listaProdutos", null)}
                                                            onChange={(_, newValue) => {
                                                                if (newValue) {
                                                                    const categoriaJaExiste = cards.some(
                                                                        (c) => c.id === newValue.idCategoria
                                                                    );

                                                                    if (categoriaJaExiste) {
                                                                        setValue("listaProdutos", null);
                                                                        return;
                                                                    }

                                                                    field.onChange(newValue);

                                                                    const produtosCategoria = produtos?.filter(p => p.id_categoria === newValue.idCategoria);

                                                                    produtosCategoria?.forEach(produto => {
                                                                        if (produto) {
                                                                            const isActive = produto.status === 1 || produto.status === true || produto.status === 'ativo';

                                                                            register(`permissoes[${produto.id}].id_produto`, { value: produto.id });
                                                                            register(`permissoes[${produto.id}].id_categoria`, { value: produto.idCategoria || produto.id_categoria});
                                                                            register(`permissoes[${produto.id}].periodo`, { value: produto.periodo || newValue.periodo });
                                                                            register(`permissoes[${produto.id}].ponto_alerta`, { value: produto.ponto_alerta || newValue.ponto_alerta });
                                                                            register(`permissoes[${produto.id}].status`, { value: isActive });
                                                                        }
                                                                    });

                                                                    const categoriaCompleta = categoriasEProdutos.find(
                                                                        (cat) => cat.id === newValue.idCategoria
                                                                    );

                                                                    const categoriaParaAdicionar = categoriaCompleta || {
                                                                        id: newValue.idCategoria,
                                                                        nome: newValue.nomeCategoria,
                                                                        quantidade_maxima: newValue.quantidade_maxima_categoria || null,
                                                                        periodo: newValue.periodo_categoria || newValue.periodo || null,
                                                                        ponto_alerta: newValue.ponto_alerta_categoria || newValue.ponto_alerta || null,
                                                                        produtos: [newValue]
                                                                    };

                                                                    const categoriaInfo = {
                                                                        id_categoria: categoriaParaAdicionar.id,
                                                                        nome: categoriaParaAdicionar.nome,
                                                                        quantidade_maxima: categoriaParaAdicionar.quantidade_maxima,
                                                                        periodo: categoriaParaAdicionar.periodo,
                                                                        ponto_alerta: categoriaParaAdicionar.ponto_alerta,
                                                                    };

                                                                    if (!getValues(`categorias[${newValue.idCategoria}]`)) {
                                                                        register(`categorias[${newValue.idCategoria}]`, {
                                                                            value: categoriaInfo,
                                                                        });
                                                                    } else {
                                                                        setValue(`categorias[${newValue.idCategoria}]`, categoriaInfo);
                                                                    }

                                                                    setCards((prevState) => [
                                                                        ...prevState,
                                                                        categoriaParaAdicionar
                                                                    ]);

                                                                    setSelectedCard(categoriaParaAdicionar.id);
                                                                    setSelectedCardInfo(categoriaParaAdicionar);
                                                                }
                                                            }}
                                                            noOptionsText={
                                                                produtos.length === 0 && cards.length === 0 ? (
                                                                    <Alert severity="error">
                                                                        Nenhum produto encontrado para a empresa selecionada.
                                                                    </Alert>
                                                                ) : (
                                                                    "Nenhum produto disponível"
                                                                )
                                                            }
                                                            loading={isLoading}
                                                            loadingText={<CircularProgress size={15} />}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Buscar Produto"
                                                                    variant="outlined"
                                                                    helperText={isLoading ? "Carregando..." : "Busque por nome, CA, código ou categoria"}
                                                                    disabled={isLoading || !allowInteraction}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <>
                                                                                {isLoading ? (
                                                                                    <CircularProgress color="inherit" size={20} />
                                                                                ) : null}
                                                                                {params.InputProps.endAdornment}
                                                                            </>
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                />
                                            </Stack>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                height: '100%',
                                                boxShadow: 1,
                                            }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 2,
                                                pb: 2,
                                                borderBottom: '2px solid',
                                                borderColor: 'divider'
                                            }}>
                                                <CategoryIcon color="primary" />
                                                <Typography variant='h6' component={'h3'} fontWeight={600}>
                                                    Selecionadas
                                                </Typography>
                                            </Box>

                                            {isLoading ? (
                                                <Box display="flex" alignItems="center" justifyContent="center" gap={2} p={4}>
                                                    <CircularProgress size={20} />
                                                    <Typography variant="body1">Carregando...</Typography>
                                                </Box>
                                            ) : (
                                                <>
                                                    {cards.length === 0 ? (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                minHeight: '325px',
                                                                p: 3,
                                                                border: '2px dashed',
                                                                borderColor: 'divider',
                                                                borderRadius: 2,
                                                                bgcolor: 'white'
                                                            }}
                                                        >
                                                            <CategoryIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                                                            <Typography variant="body1" color="text.secondary" textAlign="center">
                                                                Nenhuma categoria selecionada
                                                            </Typography>
                                                            <Typography variant="body2" color="text.disabled" textAlign="center" mt={1}>
                                                                Use o campo de busca ao lado
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                placeholder="Filtrar categorias..."
                                                                value={searchCategoria}
                                                                onChange={(e) => setSearchCategoria(e.target.value)}
                                                                sx={{ mb: 2 }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <SearchIcon fontSize="small" />
                                                                        </InputAdornment>
                                                                    ),
                                                                    endAdornment: searchCategoria && (
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={() => setSearchCategoria('')}
                                                                            >
                                                                                <ClearIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />

                                                            <Box sx={{
                                                                mb: 1.5,
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            }}>
                                                                <Typography variant="caption" color="text.secondary" fontWeight={500}>
                                                                    {categoriasOrdenadas.length} de {cards.length} categoria{cards.length !== 1 ? 's' : ''}
                                                                </Typography>
                                                                {searchCategoria && (
                                                                    <Chip
                                                                        label={`"${searchCategoria}"`}
                                                                        size="small"
                                                                        onDelete={() => setSearchCategoria('')}
                                                                        sx={{ height: 22 }}
                                                                    />
                                                                )}
                                                            </Box>

                                                            <Box sx={{
                                                                maxHeight: '450px',
                                                                overflowY: 'auto',
                                                                pr: 0.5,
                                                                '& > *:not(:last-child)': {
                                                                    mb: 1.5
                                                                }
                                                            }}>
                                                                {categoriasOrdenadas.length > 0 ? (
                                                                    categoriasOrdenadas.map((card) => {
                                                                        const isSelected = selectedCard === card.id;
                                                                        const produtosCount = card?.produtos?.length || 0;

                                                                        return (
                                                                            <Card
                                                                                key={card.id}
                                                                                onClick={() => {
                                                                                    if (allowInteraction) {
                                                                                        setSelectedCard(card.id);
                                                                                        setSelectedCardInfo(card);
                                                                                    }
                                                                                }}
                                                                                sx={{
                                                                                    cursor: allowInteraction ? 'pointer' : 'default',
                                                                                    transition: 'all 0.2s ease-in-out',
                                                                                    border: '2px solid',
                                                                                    borderColor: isSelected ? 'primary.main' : 'divider',
                                                                                    bgcolor: isSelected
                                                                                        ? 'rgba(25, 118, 210, 0.08)'
                                                                                        : 'background.paper',
                                                                                    '&:hover': allowInteraction ? {
                                                                                        transform: 'translateY(-0.5px)',
                                                                                        boxShadow: 3,
                                                                                        borderColor: isSelected ? 'primary.main' : 'primary.light'
                                                                                    } : {},
                                                                                    opacity: allowInteraction ? 1 : 0.6,
                                                                                    backgroundColor: isSelected ? 'rgba(30,81,57,0.12)' : 'none'
                                                                                }}
                                                                                elevation={isSelected ? 3 : 1}
                                                                            >
                                                                                <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                                                                        
                                                                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                                            <Typography
                                                                                                variant="subtitle2"
                                                                                                sx={{
                                                                                                    fontWeight: isSelected ? 600 : 500,
                                                                                                    color: isSelected ? 'primary.main' : 'text.primary',
                                                                                                    mb: 0.5,
                                                                                                    overflow: 'hidden',
                                                                                                    textOverflow: 'ellipsis',
                                                                                                    display: '-webkit-box',
                                                                                                    WebkitLineClamp: 2,
                                                                                                    WebkitBoxOrient: 'vertical',
                                                                                                    lineHeight: 1.3,
                                                                                                    fontSize: '1.2rem'
                                                                                                }}
                                                                                            >
                                                                                                {card.nome}
                                                                                            </Typography>

                                                                                            <Box sx={{
                                                                                                display: 'flex',
                                                                                                gap: 0.75,
                                                                                                flexWrap: 'wrap',
                                                                                                mt: 1
                                                                                            }}>
                                                                                                <Chip
                                                                                                    label={`${produtosCount} produto${produtosCount !== 1 ? 's' : ''}`}
                                                                                                    size="small"
                                                                                                    variant={isSelected ? 'filled' : 'outlined'}
                                                                                                    color={isSelected ? 'primary' : 'default'}
                                                                                                    sx={{
                                                                                                        height: 22,
                                                                                                        fontSize: '0.7rem',
                                                                                                        fontWeight: 500
                                                                                                    }}
                                                                                                />

                                                                                                {card.quantidade_maxima && (
                                                                                                    <Chip
                                                                                                        label={`Máx: ${card.quantidade_maxima}`}
                                                                                                        size="small"
                                                                                                        variant='outlined'
                                                                                                        color={isSelected ? 'primary' : 'default'}
                                                                                                        sx={{
                                                                                                            height: 22,
                                                                                                            fontSize: '0.7rem'
                                                                                                        }}
                                                                                                    />
                                                                                                )}

                                                                                                {card.periodo && (
                                                                                                    <Chip
                                                                                                        label={`Período: ${card.periodo}`}
                                                                                                        size="small"
                                                                                                        variant='outlined'
                                                                                                        color={isSelected ? 'primary' : 'default'}
                                                                                                        sx={{
                                                                                                            height: 22,
                                                                                                            fontSize: '0.7rem'
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </Box>
                                                                                        </Box>

                                                                                        {allowInteraction && (
                                                                                            <Tooltip title="Remover categoria">
                                                                                                <IconButton
                                                                                                    size="small"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        const id = card.id;
                                                                                                        const isExistingCard = existingCards.find(c => c.id === id);

                                                                                                        if (isExistingCard) {
                                                                                                            setValue(`categorias[${card.id}].deletePermissions`, true);
                                                                                                        } else {
                                                                                                            unregister(`categorias[${card.id}]`);
                                                                                                        }

                                                                                                        card?.produtos?.forEach(produto => {
                                                                                                            unregister(`permissoes[${produto.id}]`);
                                                                                                        });

                                                                                                        setCards(cards.filter(c => c.id !== id));
                                                                                                        if (selectedCard === id) {
                                                                                                            setSelectedCard(null);
                                                                                                        }
                                                                                                    }}
                                                                                                    sx={{
                                                                                                        color: 'grey',
                                                                                                        '&:hover': {
                                                                                                            bgcolor: 'rgb(202,202,202)'
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    <DeleteIcon fontSize="small" />
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                        )}
                                                                                    </Box>
                                                                                </CardContent>
                                                                            </Card>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <Box
                                                                        sx={{
                                                                            textAlign: 'center',
                                                                            py: 4,
                                                                            color: 'text.secondary'
                                                                        }}
                                                                    >
                                                                        <SearchIcon sx={{ fontSize: 40, mb: 1, opacity: 0.5 }} />
                                                                        <Typography variant="body2">
                                                                            Nenhuma categoria encontrada
                                                                        </Typography>
                                                                        <Typography variant="caption" color="text.disabled">
                                                                            Tente outro termo de busca
                                                                        </Typography>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                height: '100%',
                                                boxShadow: 1
                                            }}
                                        >
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 2,
                                                pb: 2,
                                                borderBottom: '2px solid',
                                                borderColor: 'divider'
                                            }}>
                                                <SecurityIcon color="primary" />
                                                <Typography variant='h6' component={'h3'} fontWeight={600}>
                                                    Permissões
                                                </Typography>
                                            </Box>

                                            <Box
                                                sx={{
                                                    height: '500px',
                                                    borderRadius: 2,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    p: 2,
                                                    overflowY: 'auto',
                                                    bgcolor: 'background.paper',
                                                    '& > *': {
                                                        marginTop: 1,
                                                        marginBottom: 1,
                                                    },
                                                }}
                                            >
                                                {isLoading ? (
                                                    <Box display="flex" alignItems="center" justifyContent="center" gap={2} p={4}>
                                                        <CircularProgress size={20} />
                                                        <Typography variant="body1">Carregando...</Typography>
                                                    </Box>
                                                ) : (
                                                    <StepCategoriaEProdutos
                                                        control={control}
                                                        register={register}
                                                        errors={errors}
                                                        setValue={setValue}
                                                        getValues={getValues}
                                                        watch={watch}
                                                        selectedCard={selectedCard}
                                                        cards={cards}
                                                        selectedCardInfo={selectedCardInfo}
                                                        allowInteraction={allowInteraction}
                                                        exibirAlerta={exibirAlerta}
                                                    />
                                                )}
                                            </Box>
                                        </Paper>
                                    </Grid>
                                </Grid>

                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    mt: 4,
                                    pt: 3,
                                    borderTop: '1px solid',
                                    borderColor: 'divider'
                                }}>
<Button
    onClick={handleBack}
    disabled={!allowInteraction}
    size="large"
    startIcon={<ArrowBackIcon />}
>
    Voltar
</Button>
                                </Box>
                            </>
                        )}
                        
                    </Box>
                )}
            </FormControl>
        </>
    )
}